export function getFormatOraInput(data, format) {
  let moment = require("moment");
  return format ? moment(data, format).format("YYYY-MM-DD") : moment(data).format("YYYY-MM-DD");
}

export function getDataFormat(data) {
  var moment = require("moment");
  return moment(data).format("DD/MM/YYYY");
}

export function getDataFormatWithTime(data, format) {
  var moment = require("moment");
  return format ? moment(data, format).format("DD/MM/YYYY - HH:mm") : moment(data).format("DD/MM/YYYY - HH:mm");
}

export function limitDate() {
  let date = new Date();

  // Ottieni le parti della data
  let year = date.getFullYear(); // Anno a 4 cifre
  let month = String(date.getMonth() + 1).padStart(2, '0'); // Mese (01-12)
  let day = String(date.getDate()).padStart(2, '0'); // Giorno (01-31)
  let hours = String(date.getHours()).padStart(2, '0'); // Ore (00-23)
  let minutes = String(date.getMinutes()).padStart(2, '0'); // Minuti (00-59)

  // Formatta la data nel formato "YYYY-MM-DDTHH:MM"
  let formattedDate = year + '-' + month + '-' + day + 'T' + hours + ':' + minutes;

  return formattedDate;
}

export function checkDateDifference(d1, d2, limit=90) {
  // Convertire le date in oggetti Date se non lo sono già
  const date1 = new Date(d1);
  const date2 = new Date(d2);

  // Calcolare la differenza in millisecondi
  const differenzaMs = Math.abs(date2 - date1);

  // Convertire la differenza in millisecondi in giorni
  const differenzaGiorni = differenzaMs / (1000 * 60 * 60 * 24);

  // Restituire true se la differenza è maggiore del limite
  return differenzaGiorni > limit;
}
